export function buildLiveblogSubmitData(form, { isCreate = false } = {}) {
    const data = { ...form }
    const imageFile = data.image_file
    const galleryItems = data.gallery_items || []
    delete data.image_file
    delete data.gallery_items
    delete data.player_name
    delete data.related_player_name
    delete data.event_type_name
    delete data.event_reason_name
    delete data.period_name

    // Let the API assign event_id on create (avoids collision with sport events / duplicates).
    if (isCreate) {
        delete data.event_id
    }

    Object.keys(data).forEach((key) => {
        if (data[key] === '' || data[key] === null) delete data[key]
    })

    if (data.content_type === 'event' || data.content_type === 'text') {
        delete data.payload
    }

    if (data.content_type === 'image' && imageFile) {
        const formData = new FormData()
        Object.keys(data).forEach((key) => {
            if (key === 'payload') return
            formData.append(key, data[key])
        })
        formData.append('payload[url]', imageFile)
        return formData
    }

    if (data.content_type === 'twitter' && data.payload && typeof data.payload === 'object') {
        const payload = {}
        ;['url', 'tweet_id', 'author'].forEach((key) => {
            const value = data.payload[key]
            if (value != null && String(value).trim() !== '') {
                payload[key] = String(value).trim()
            }
        })
        data.payload = Object.keys(payload).length ? payload : null
    }

    if (data.content_type === 'video' && data.payload && typeof data.payload === 'object') {
        const payload = {}
        ;['url', 'embed_id', 'provider'].forEach((key) => {
            const value = data.payload[key]
            if (value != null && String(value).trim() !== '') {
                payload[key] = String(value).trim()
            }
        })
        data.payload = Object.keys(payload).length ? payload : null
    }

    if (data.content_type === 'gallery') {
        const entries = galleryItems.filter(
            (item) =>
                item &&
                (item.file ||
                    (item.url && String(item.url).trim() && /^https?:\/\//i.test(String(item.url).trim())))
        )
        const hasFile = entries.some((item) => item.file)

        if (hasFile) {
            const formData = new FormData()
            Object.keys(data).forEach((key) => {
                if (key === 'payload') return
                formData.append(key, data[key])
            })
            entries.forEach((item, index) => {
                if (item.file) {
                    formData.append(`payload[images][${index}][url]`, item.file)
                } else {
                    formData.append(`payload[images][${index}][url]`, String(item.url).trim())
                }
            })
            return formData
        }

        data.payload = {
            images: entries.map((item) => ({ url: String(item.url).trim() })),
        }
    }

    return data
}
